module.exports = __webpack_public_path__ + "img/banner@2x.c5d9e254.png";